import { useIsOnline } from '@/application/outbox/useOutboxSync';
import { Freshness } from '@/ui/feedback/Freshness';

/** What a list's query says about how fresh it is, and how to ask again. */
export interface FreshQuery {
  dataUpdatedAt: number;
  isFetching: boolean;
  isRefetchError: boolean;
  refetch: () => Promise<unknown>;
}

/**
 * The refresh button and "Updated just now" in a list's header. Request of
 * 4 October 2026, section 8. Offline, or after a failed refresh, it says the
 * list is the saved copy instead.
 */
export function ListFreshness({ query }: { query: FreshQuery }) {
  const online = useIsOnline();
  return (
    <Freshness
      updatedAt={query.dataUpdatedAt}
      fetching={query.isFetching}
      stale={query.dataUpdatedAt > 0 && (!online || query.isRefetchError)}
      onRefresh={() => void query.refetch()}
      inHeader
    />
  );
}
